import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "indicator", "label", "counter", "stepsContainer", "playBtn"]
  static values = {
    current: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    autoPlay: { type: Boolean, default: false },
    duration: { type: Number, default: 600 }
  }

  connect() {
    this.autoPlayTimer = null
    if (this.autoPlayValue) {
      this.startAutoPlay()
    }
  }

  disconnect() {
    this.stopAutoPlay()
  }

  next() {
    const nextIndex = this.currentValue + 1
    if (nextIndex < this.totalValue) {
      this.goTo({ params: { step: nextIndex } })
    } else {
      // Wrap around to first step
      this.goTo({ params: { step: 0 } })
    }
  }

  previous() {
    const prevIndex = this.currentValue - 1
    if (prevIndex >= 0) {
      this.goTo({ params: { step: prevIndex } })
    } else {
      // Wrap around to last step
      this.goTo({ params: { step: this.totalValue - 1 } })
    }
  }

  goTo(event) {
    const index = event.params?.step ?? parseInt(event.currentTarget?.dataset?.step ?? 0, 10)
    if (index < 0 || index >= this.totalValue || index === this.currentValue) return

    const currentStep = this.stepTargets[this.currentValue]
    const nextStep = this.stepTargets[index]

    if (currentStep) {
      currentStep.classList.remove("is-active")
      currentStep.hidden = true
    }

    if (nextStep) {
      nextStep.hidden = false
      // Force reflow before adding class for CSS transition
      nextStep.offsetHeight
      nextStep.classList.add("is-active")
    }

    // Update indicators
    this.indicatorTargets.forEach((dot, i) => {
      dot.classList.toggle("is-active", i === index)
    })

    // Update counter
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `Step ${index + 1} of ${this.totalValue}`
    }

    // Update label
    if (this.hasLabelTarget && nextStep) {
      const label = nextStep.dataset.stepLabel || ""
      this.labelTarget.textContent = label
    }

    this.currentValue = index
  }

  toggleAutoPlay() {
    if (this.autoPlayTimer) {
      this.stopAutoPlay()
    } else {
      this.startAutoPlay()
    }
  }

  startAutoPlay() {
    this.autoPlayTimer = setInterval(() => {
      this.next()
    }, this.durationValue + 1000) // Duration + 1s pause between steps

    if (this.hasPlayBtnTarget) {
      const playIcon = this.playBtnTarget.querySelector(".content-block-walkthrough__play-icon")
      const pauseIcon = this.playBtnTarget.querySelector(".content-block-walkthrough__pause-icon")
      if (playIcon) playIcon.style.display = "none"
      if (pauseIcon) pauseIcon.style.display = ""
    }
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer)
      this.autoPlayTimer = null
    }

    if (this.hasPlayBtnTarget) {
      const playIcon = this.playBtnTarget.querySelector(".content-block-walkthrough__play-icon")
      const pauseIcon = this.playBtnTarget.querySelector(".content-block-walkthrough__pause-icon")
      if (playIcon) playIcon.style.display = ""
      if (pauseIcon) pauseIcon.style.display = "none"
    }
  }
}
